<!-- <ng-container *ngIf="formOptions">
    <ubs-ofbiz-view-form [value]="value" [componentConfig]="componentConfig" [options]="formOptions"></ubs-ofbiz-view-form>
</ng-container> -->
<ubs-ofbiz-view-list [value]="value" [componentConfig]="componentConfig" [options]="options"></ubs-ofbiz-view-list>
